<template>
    <div id="requests">
        <RequestsTable
            :requestParams="{
                officerId: officer.id
            }"
            :showClient="true"
            :showOfficer="false"
            emptyText="This officer has not responded to any requests."
        />
    </div>
</template>

<script>
import RequestsTable from '../../requests/requests-table';

export default {
    props: ['officer'],

    components: { RequestsTable },

    mounted() {
        this.$el.parentElement.parentElement.parentElement.style.maxWidth = 'none';
        this.$el.parentElement.parentElement.parentElement.style.width = 'auto';
    },

    beforeUnmount() {
        this.$el.parentElement.parentElement.parentElement.style.removeProperty('max-width');
        this.$el.parentElement.parentElement.parentElement.style.removeProperty('width');
    }
};
</script>

<style lang="scss" scoped></style>
